<form autocomplete="off" [formGroup]="cadastrarSenhaForm" (ngSubmit)="onSubmit()">
  <div class="row">
    <div class="col-sm-6 offset-sm-3">
      <div class="card">
        <div class="card-header">
          <strong>Cadastrar Senha</strong>
        </div>
        <div class="card-body">

          <div class="row" *ngIf="msgErroCadastroSenha">
            <div class="col-sm-12">
              <div class="alert alert-danger" role="alert">
                {{msgErroCadastroSenha}}
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="nomeMae">Nome da Mãe</label>
                <input type="text" 
                       class="form-control"
                       name="nomeMae"
                       id="nomeMae"
                       placeholder="Digite o nome da mãe" 
                       formControlName="nomeMae">
             
                <!-- <div *ngFor="let error of formErrors.nomeMae" class="alert alert-danger">
                  {{ error }}
                </div> -->
                
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="dataNascimento">Data de Nascimento</label>
                  <div class="form-group">
                      <input class="form-control" 
                            id="dataNascimento" 
                            name="dataNascimento" 
                            placeholder="dd/mm/aaaa"
                            formControlName="dataNascimento"
                            [textMask]="maskData"
                            (keyup)="LimparErros($event)">
                  </div>                            

                <!-- <div *ngFor="let error of formErrors.dataNascimento" class="alert alert-danger">
                  {{ error }}
                </div> -->

              </div>
            </div>
          </div>
          <!--/.row-->
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="senha">Senha para acesso ao Portal</label>
                <input type="password" autocomplete="new-password" class="form-control" id="senha" name="senha" placeholder="Digite a sua Senha" formControlName="senha" maxlength="50">

                <div *ngFor="let error of formErrors.senha" class="alert alert-danger">
                  {{ error }}
                </div>

              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="senha">Confirmar senha</label>
                <input type="password" autocomplete="new-password" class="form-control" id="confirmarSenha" name="confirmarSenha" placeholder="Digite a sua Senha" formControlName="confirmarSenha" maxlength="50">

                <div *ngFor="let error of formErrors.confirmarSenha" class="alert alert-danger">
                  {{ error }}
                </div>

              </div>
            </div>
          </div>
          <!--/.row-->
          <!-- <div class="row" *ngIf="this.useRecaptcha">
            <div class="col-sm-12 section-block small-text" style="font-size: 11px;">
              <re-captcha (resolved)="resolved($event)" siteKey="{{ recaptcha }}"></re-captcha>
            </div>
          </div>           -->
          <div class="row col-6">
            <div>
              <button class="btn btn-bluelight"  [disabled]="!cadastrarSenhaForm.valid" 
                      data-toggle="tooltip" data-placement="top" title="Confirmar">
                Confirmar
              </button>         
           </div>
            <div  class="col-2">
              <button class="btn btn-danger" 
                      data-toggle="tooltip" data-placement="top" title="Cancelar" routerLink="/consumidor">
                Cancelar
              </button>         
           </div>
          </div>

          <!--/.row-->
        </div>
      </div>
    </div>
    <!--/.col-->
  </div>
</form>


// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-cadastrar-senha-externo/consumidor-cadastrar-senha-externo.component.html